import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import {
  Footer,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
  NamedLink,
  JoinPreFooter,
} from '../../components';

import { TopbarContainer } from '..';
import { FormattedMessage } from '../../util/reactIntl';

import css from './SuccessStoriesPage.css';

import hartwallLogo from '../../assets/hartwall-logo.svg';
import peikkoLogo from '../../assets/peikko-group-logo.png';
import systamLogo from '../../assets/systam-logo.svg';
import eerikkilaLogo from '../../assets/eerikkila-logo.svg';
import coregoLogo from '../../assets/corego-logo.png';
import fundisLogo from '../../assets/fundis-logo.svg';
import piirlaLogo from '../../assets/piirla-logo.png';
import tulusLogo from '../../assets/tulus-logo.svg';
import zervantLogo from '../../assets/zervant-logo.svg';

import mismeAvatar from '../../assets/misme_halonen-quote.jpeg';
import markusAvatar from '../../assets/markus-dyer-quote.png';
import emmiAvatar from '../../assets/systam-success-story-quote2.webp';
import lauraAvatar from '../../assets/eerikkila-success-story-quote.webp';
import hannaMariaAvatar from '../../assets/corego-success-story-quote.png';
import seppoAvatar from '../../assets/fundis-success-story-quote.webp';
import liisaAvatar from '../../assets/tulus-success-story-quote.png';

export const SuccessStoriesPageComponent = props => {
  const { intl, scrollingDisabled } = props;

  // Schema for search engines (helps them to understand what this page is about)
  // http://schema.org
  // We are using JSON-LD format
  const schemaTitle = intl.formatMessage({ id: 'SuccessStoriesPage.schemaTitle' });
  const schemaDescription = intl.formatMessage({ id: 'SuccessStoriesPage.schemaDescription' });

  const successStoriesArray = [
    {
      title: <FormattedMessage id="SuccessStoriesPage.hartwallXfreedomly" />,
      description: <FormattedMessage id="SuccessStoriesPage.cardTextHartwall" />,
      logo: hartwallLogo,
      logoAlt: 'Hartwall',
      avatar: mismeAvatar,
      avatarAlt: 'Misme Halonen',
      page: 'SuccessStoryHartwallPage',
    },
    {
      title: <FormattedMessage id="SuccessStoriesPage.peikkoXfreedomly" />,
      description: <FormattedMessage id="SuccessStoriesPage.cardTextPeikko" />,
      logo: peikkoLogo,
      logoAlt: 'Peikko',
      avatar: markusAvatar,
      avatarAlt: 'Markus Dyer',
      page: 'SuccessStoryPeikkoPage',
    },
    {
      title: <FormattedMessage id="SuccessStoriesPage.systamXfreedomly" />,
      description: <FormattedMessage id="SuccessStoriesPage.cardTextSystam" />,
      logo: systamLogo,
      logoAlt: 'Systam',
      avatar: emmiAvatar,
      avatarAlt: 'Emmi Kurru',
      page: 'SuccessStorySystamPage',
    },
    {
      title: <FormattedMessage id="SuccessStoriesPage.eerikkilaXfreedomly" />,
      description: <FormattedMessage id="SuccessStoriesPage.cardTextEerikkila" />,
      logo: eerikkilaLogo,
      logoAlt: 'Eerikkilä',
      avatar: lauraAvatar,
      avatarAlt: 'Laura Sirén',
      page: 'SuccessStoryEerikkilaPage',
    },
    {
      title: <FormattedMessage id="SuccessStoriesPage.coregoXfreedomly" />,
      description: <FormattedMessage id="SuccessStoriesPage.cardTextCorego" />,
      logo: coregoLogo,
      logoAlt: 'CoreGo',
      avatar: hannaMariaAvatar,
      avatarAlt: 'Hanna Maria Pinta',
      page: 'SuccessStoryCoregoPage',
    },
    {
      title: <FormattedMessage id="SuccessStoriesPage.fundisXfreedomly" />,
      description: <FormattedMessage id="SuccessStoriesPage.cardTextFundis" />,
      logo: fundisLogo,
      logoAlt: 'Fundis',
      avatar: seppoAvatar,
      avatarAlt: 'Seppo Kuusinen',
      page: 'SuccessStoryFundisPage',
    },
    {
      title: <FormattedMessage id="SuccessStoriesPage.piirlaXfreedomly" />,
      description: <FormattedMessage id="SuccessStoriesPage.cardTextPiirla" />,
      logo: piirlaLogo,
      logoAlt: 'Piirla',
      page: 'SuccessStoryPiirlaPage',
    },
    {
      title: <FormattedMessage id="SuccessStoriesPage.tulusXfreedomly" />,
      description: <FormattedMessage id="SuccessStoriesPage.cardTextTulus" />,
      logo: tulusLogo,
      logoAlt: 'Tulus',
      avatar: liisaAvatar,
      avatarAlt: 'Liisa Svanberg',
      page: 'SuccessStoryTulusPage',
    },
    {
      title: <FormattedMessage id="SuccessStoriesPage.zervantXfreedomly" />,
      description: <FormattedMessage id="SuccessStoriesPage.cardTextZervant" />,
      logo: zervantLogo,
      logoAlt: 'Zervant',
      page: 'SuccessStoryZervantPage',
    },
  ];

  const SuccessStoryCard = props => {
    const { title, description, logo, logoAlt, avatar, avatarAlt, page } = props;

    return (
      <NamedLink name={page} className={css.cardLink}>
        <div className={css.cardImageBand}>
          <div className={css.logoPlate}>
            {avatar ? (
              <img src={avatar} alt={avatarAlt} className={css.cardAvatar} loading="lazy" />
            ) : null}
            <img src={logo} alt={logoAlt} className={css.cardLogo} loading="lazy" />
          </div>
        </div>
        <div className={css.cardBody}>
          <h2 className={css.cardTitle}>{title}</h2>
          <p className={css.cardDescription}>{description}</p>
          <div className={css.readStoryPill}>
            <FormattedMessage id="SuccessStoriesPage.readStory" />
          </div>
        </div>
      </NamedLink>
    );
  };

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="SuccessStoriesPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.contentWrapper}>
            <div className={css.heroSection}>
              <div className={css.heroContent}>
                <h1 className={css.heroTitle}>
                  <FormattedMessage id="SuccessStoriesPage.heroTitle" />
                </h1>
                <p className={css.heroSubtitle}>
                  <FormattedMessage id="SuccessStoriesPage.heroSubtitle" />
                </p>
              </div>
            </div>
            <div className={css.successStoryCards}>
              {successStoriesArray.map(story => (
                <SuccessStoryCard
                  title={story.title}
                  description={story.description}
                  logo={story.logo}
                  logoAlt={story.logoAlt}
                  avatar={story.avatar}
                  avatarAlt={story.avatarAlt}
                  page={story.page}
                  key={story.page}
                />
              ))}
            </div>
          </div>
          <JoinPreFooter showContactButton />
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const SuccessStoriesPage = compose(
  withRouter,
  connect(mapStateToProps),
  injectIntl
)(SuccessStoriesPageComponent);

export default SuccessStoriesPage;
